import { ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { EditableGridComponent } from '@common/components/editable-grid/editable-grid.component';
import { User } from '@common/models/User';
import { BreezeService } from '@common/services/breeze.service';
import { GridEditService } from '@common/services/grid-edit.service';
import { VesselNotificationWasteGridComponent } from '../vessel-notification-waste-grid/vessel-notification-waste-grid.component';

@Component({
    selector: 'app-vessel-notification-waste',
    templateUrl: './vessel-notification-waste.component.html',
    styleUrls: ['./vessel-notification-waste.component.scss'],
    providers: [BreezeService, GridEditService]
})
export class VesselNotificationWasteComponent {
    @Input() model: any;
    @Input() canEdit: boolean;
    @Input() editMode: any;
    @Input() user: User;
}
